import { alertActions } from 'srcReact/Alert'
import { uuid } from 'srcReact/helpers/utils'
import { messengerConstants as mc } from 'srcReact/MessengerPage'
import { messengerService } from 'srcReact/services'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { getLinksFromMessage, getParsedMessage, getTaggedUserIds } from 'srcReact/helpers/feedHelper'

const PAGINATION_QUANTITY = appConstantSettings.PAGINATION_QUANTITY

export const messengerActions = {
  createConversation,
  renameConversation,
  addMembersToConversation,
  removeMembersFromConversation,
  leaveConversation,
  resumeConversation,
  muteConversation,
  unmuteConversation,
  hideConversation,
  deleteConversation,
  postMessage,
  updateMessage,
  deleteMessage,
  setAdmin,
  clearError,

  addReactionToMessage,
  deleteReactionFromMessage,
  setFromLightProfile,
  showSidebar,
  showMainContent,
  setOriginMessage,
  setOrganizationId,
  setSideBarScreenType,
  searchMembers,
  getConversationsList,
  getConversationsListPagination,
  getConversationsSearch,
  getConversationsCheckUpdates,
  openConversationCheckUpdates,
  getConversationOpen,
  getConversationOpenPagination,
  openConversationFromNotificationLink,
  createConversationFromMailLink,
  saveDraftMessage,
  setFilterItem,
  addToPendingMessages,
  removeFromPendingMessages,
  locateMessageInConversation,
  resetScrollToMessage,
  createBackgroundTagMsgr,
  updateProcessedTag
}

function clearError() {
  return {
    type: mc.CLEAR_ERROR
  }
}

function setFromLightProfile(flag) {
  return {
    type: mc.SET_FROM_LIGHT_PROFILE,
    flag
  }
}

function showSidebar(show) {
  return {
    type: mc.SHOW_SIDEBAR,
    show
  }
}

function showMainContent(show) {
  return {
    type: mc.SHOW_MAIN_CONTENT,
    show
  }
}

function setOriginMessage(message) {
  return {
    type: mc.SET_ORIGIN_MESSAGE,
    message
  }
}

function setSideBarScreenType(screenType) {
  return {
    type: mc.SET_SIDEBAR_SCREEN,
    screenType
  }
}

function searchMembers(search, organizationId, pagination, quantity = PAGINATION_QUANTITY) {
  const { nextOffset, isPagination } = pagination
  return (dispatch) => {
    dispatch(request(isPagination))

    messengerService.searchMember(search, organizationId, nextOffset, quantity).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(isPagination) {
    return { type: mc.SEARCH_MEMBER_REQUEST, isPagination }
  }
  function success(response) {
    const updatedResponse = { ...response, isPagination, search }
    return { type: mc.SEARCH_MEMBER_SUCCESS, updatedResponse }
  }
  function failure(error) {
    return { type: mc.SEARCH_MEMBER_FAILURE, error }
  }
}

function createConversation(organizationId, userIds) {
  return (dispatch) => {
    dispatch(request(organizationId, userIds))

    messengerService.createConversation(organizationId, userIds).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.CREATE_CONV_REQUEST, response }
  }
  function success(response) {
    return { type: mc.CREATE_CONV_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.CREATE_CONV_FAILURE, error }
  }
}

function renameConversation(conversationId, name) {
  return (dispatch) => {
    dispatch(request(conversationId, name))

    messengerService.renameConversation(conversationId, name).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.RENAME_CONV_REQUEST, response }
  }
  function success(response) {
    return { type: mc.RENAME_CONV_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.RENAME_CONV_FAILURE, error }
  }
}

function addMembersToConversation(conversationId, userIds) {
  return (dispatch) => {
    dispatch(request(conversationId, userIds))

    messengerService.addMembersToConversation(conversationId, userIds).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.ADD_MEMBERS_TO_CONV_REQUEST, response }
  }
  function success(response) {
    return { type: mc.ADD_MEMBERS_TO_CONV_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.ADD_MEMBERS_TO_CONV_FAILURE, error }
  }
}

function removeMembersFromConversation(conversationId, userIds) {
  return (dispatch) => {
    dispatch(request(conversationId, userIds))

    messengerService.removeMembersFromConversation(conversationId, userIds).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.REMOVE_MEMBERS_FROM_CONV_REQUEST, response }
  }
  function success(response) {
    return { type: mc.REMOVE_MEMBERS_FROM_CONV_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.REMOVE_MEMBERS_FROM_CONV_FAILURE, error }
  }
}

function leaveConversation(conversationId) {
  return (dispatch) => {
    dispatch(request(conversationId))

    messengerService.leaveConversation(conversationId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.LEAVE_CONV_REQUEST, response }
  }
  function success(response) {
    return { type: mc.LEAVE_CONV_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.LEAVE_CONV_FAILURE, error }
  }
}

function resumeConversation(conversationId) {
  return (dispatch) => {
    dispatch(request(conversationId))

    messengerService.resumeConversation(conversationId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.RESUME_CONV_REQUEST, response }
  }
  function success(response) {
    return { type: mc.RESUME_CONV_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.RESUME_CONV_FAILURE, error }
  }
}

function muteConversation(conversationId) {
  return (dispatch) => {
    dispatch(request(conversationId))

    messengerService.muteConversation(conversationId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.MUTE_CONV_REQUEST, response }
  }
  function success(response) {
    return { type: mc.MUTE_CONV_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.MUTE_CONV_FAILURE, error }
  }
}

function unmuteConversation(conversationId) {
  return (dispatch) => {
    dispatch(request(conversationId))

    messengerService.unmuteConversation(conversationId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.UNMUTE_CONV_REQUEST, response }
  }
  function success(response) {
    return { type: mc.UNMUTE_CONV_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.UNMUTE_CONV_FAILURE, error }
  }
}

function hideConversation(conversationId) {
  return (dispatch) => {
    dispatch(request(conversationId))

    messengerService.hideConversation(conversationId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.HIDE_CONV_REQUEST, response }
  }
  function success(response) {
    return { type: mc.HIDE_CONV_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.HIDE_CONV_FAILURE, error }
  }
}

function deleteConversation(conversationId) {
  return (dispatch) => {
    dispatch(request(conversationId))

    messengerService.deleteConversation(conversationId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.DELETE_CONV_REQUEST, response }
  }
  function success(response) {
    return { type: mc.DELETE_CONV_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.DELETE_CONV_FAILURE, error }
  }
}

function postMessage(conversationId, message, originMessageId = null, fileIds = null, tempMessageId) {
  const parsedMessage = getParsedMessage(message)
  const taggedUserIds = getTaggedUserIds(parsedMessage)
  const containedLinks = getLinksFromMessage(parsedMessage)
  return (dispatch) => {
    dispatch(request(conversationId, tempMessageId))

    messengerService.postMessage(conversationId, message, originMessageId, fileIds, taggedUserIds, containedLinks).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(conversationId, tempMessageId) {
    return {
      type: mc.POST_MESSAGE_REQUEST,
      conversationId,
      tempMessageId
      // postedMessage: {
      //   message,
      //   tempId: tempMessageId,
      //   createdAt: new Date(),
      //   id_user: userId,
      //   fileIds
      // }
    }
  }
  function success(response) {
    return { type: mc.POST_MESSAGE_SUCCESS, response, tempMessageId }
  }
  function failure(error) {
    return { type: mc.POST_MESSAGE_FAILURE, error }
  }
}

function updateMessage(messageId, message, offset, quantity) {
  const parsedMessage = getParsedMessage(message)
  const taggedUserIds = getTaggedUserIds(parsedMessage)
  const containedLinks = getLinksFromMessage(parsedMessage)
  return (dispatch) => {
    dispatch(request(messageId))

    messengerService.updateMessage(messageId, message, taggedUserIds, containedLinks, offset, quantity).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.UPDATE_MESSAGE_REQUEST, response }
  }
  function success(response) {
    return { type: mc.UPDATE_MESSAGE_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.UPDATE_MESSAGE_FAILURE, error }
  }
}

function deleteMessage(messageId, offset, quantity) {
  return (dispatch) => {
    dispatch(request(messageId))

    messengerService.deleteMessage(messageId, offset, quantity).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.DELETE_MESSAGE_REQUEST, response }
  }
  function success(response) {
    return { type: mc.DELETE_MESSAGE_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.DELETE_MESSAGE_FAILURE, error }
  }
}

function setAdmin(conversationId, userId, isAdmin) {
  return (dispatch) => {
    dispatch(request(userId))

    messengerService.setAdmin(conversationId, userId, isAdmin).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.SET_ADMIN_REQUEST, response }
  }
  function success(response) {
    return { type: mc.SET_ADMIN_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.SET_ADMIN_FAILURE, error }
  }
}

function addReactionToMessage(messageId, reactionCode) {
  return (dispatch) => {
    dispatch(request({ messageId, reactionCode }))

    messengerService.addReactionToMessage(messageId, reactionCode).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.ADD_REACTION_REQUEST, response }
  }
  function success(response) {
    return { type: mc.ADD_REACTION_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.ADD_REACTION_FAILURE, error }
  }
}

function deleteReactionFromMessage(reactionId, reactionCode, messageId) {
  return (dispatch) => {
    dispatch(request({ reactionId, reactionCode, messageId }))

    messengerService.deleteReactionFromMessage(reactionId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.DELETE_REACTION_REQUEST, response }
  }
  function success(response) {
    return { type: mc.DELETE_REACTION_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.DELETE_REACTION_FAILURE, error }
  }
}

function setOrganizationId(id) {
  return {
    type: mc.SET_ORGANIZATION_ID,
    id
  }
}

function getConversationsList(
  organization_id,
  is_messenger_page = 1,
  conversations_type = 'all',
  with_open_most_recent_conversation = 0,
  offset = 0,
  quantity = PAGINATION_QUANTITY,
  content_offset = 0,
  content_quantity = PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(
      request({
        organization_id,
        is_messenger_page,
        conversations_type,
        with_open_most_recent_conversation,
        offset,
        quantity,
        content_offset,
        content_quantity
      })
    )

    messengerService
      .getConversationsList({
        organization_id,
        is_messenger_page,
        conversations_type,
        with_open_most_recent_conversation,
        offset,
        quantity,
        content_offset,
        content_quantity
      })
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
  }

  function request(data) {
    return { type: mc.GET_CONVERSATIONS_LIST_REQUEST, data }
  }
  function success(data) {
    return { type: mc.GET_CONVERSATIONS_LIST_SUCCESS, data }
  }
  function failure(error) {
    return { type: mc.GET_CONVERSATIONS_LIST_FAILURE, error }
  }
}

function getConversationsListPagination(
  organization_id,
  is_messenger_page = 1,
  conversations_type = 'all',
  with_open_most_recent_conversation = 0,
  offset = 0,
  quantity = PAGINATION_QUANTITY,
  content_offset = 0,
  content_quantity = PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(
      request({
        organization_id,
        is_messenger_page,
        conversations_type,
        with_open_most_recent_conversation,
        offset,
        quantity,
        content_offset,
        content_quantity
      })
    )

    messengerService
      .getConversationsList({
        organization_id,
        is_messenger_page,
        conversations_type,
        with_open_most_recent_conversation,
        offset,
        quantity,
        content_offset,
        content_quantity
      })
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
  }

  function request(data) {
    return { type: mc.GET_CONVERSATIONS_LIST_PAGINATION_REQUEST, data }
  }
  function success(data) {
    return { type: mc.GET_CONVERSATIONS_LIST_PAGINATION_SUCCESS, data }
  }
  function failure(error) {
    return { type: mc.GET_CONVERSATIONS_LIST_PAGINATION_FAILURE, error }
  }
}

function getConversationsSearch(
  organization_id,
  conversations_type = 'all',
  search,
  type = `conversations,users,messages`
) {
  return (dispatch) => {
    dispatch(
      request({
        organization_id,
        conversations_type,
        search,
        type
      })
    )

    messengerService.getConversationsSearch(organization_id, conversations_type, search, type).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: mc.GET_CONVERSATIONS_SEARCH_REQUEST, data }
  }
  function success(data) {
    return { type: mc.GET_CONVERSATIONS_SEARCH_SUCCESS, data }
  }
  function failure(error) {
    return { type: mc.GET_CONVERSATIONS_SEARCH_FAILURE, error }
  }
}

function getConversationsCheckUpdates(organization_id, content_offset = 0, content_quantity = PAGINATION_QUANTITY) {
  return (dispatch) => {
    dispatch(
      request({
        organization_id,
        content_offset,
        content_quantity
      })
    )

    messengerService.getConversationsCheckUpdates(organization_id, content_offset, content_quantity).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: mc.REALTIME_CONVERSATIONS_UPDATE_REQUEST, data }
  }
  function success(data) {
    return { type: mc.REALTIME_CONVERSATIONS_UPDATE_SUCCESS, data }
  }
  function failure(error) {
    return { type: mc.REALTIME_CONVERSATIONS_UPDATE_FAILURE, error }
  }
}

function openConversationCheckUpdates(conversation_id, content_offset = 0, content_quantity = PAGINATION_QUANTITY) {
  return (dispatch) => {
    dispatch(request({ conversation_id, content_offset, content_quantity }))

    messengerService.getConversationOpen(conversation_id, content_offset, content_quantity).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: mc.REALTIME_OPEN_CONVERSATION_UPDATE_REQUEST, data }
  }
  function success(data) {
    return { type: mc.REALTIME_OPEN_CONVERSATION_UPDATE_SUCCESS, data }
  }
  function failure(error) {
    return { type: mc.REALTIME_OPEN_CONVERSATION_UPDATE_FAILURE, error }
  }
}

function getConversationOpen(
  conversation,
  conversation_id,
  content_offset = 0,
  content_quantity = PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(request({ conversation, conversation_id, content_offset, content_quantity }))

    messengerService.getConversationOpen(conversation_id, content_offset, content_quantity).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: mc.GET_CONVERSATION_OPEN_REQUEST, data }
  }
  function success(data) {
    return { type: mc.GET_CONVERSATION_OPEN_SUCCESS, data }
  }
  function failure(error) {
    return { type: mc.GET_CONVERSATION_OPEN_FAILURE, error }
  }
}

function getConversationOpenPagination(conversation_id, content_offset = 0, content_quantity = PAGINATION_QUANTITY) {
  return (dispatch) => {
    dispatch(request({ conversation_id, content_offset, content_quantity }))

    messengerService.getConversationOpen(conversation_id, content_offset, content_quantity).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: mc.GET_CONVERSATION_OPEN_PAGINATION_REQUEST, data }
  }
  function success(data) {
    return { type: mc.GET_CONVERSATION_OPEN_PAGINATION_SUCCESS, data }
  }
  function failure(error) {
    return { type: mc.GET_CONVERSATION_OPEN_PAGINATION_FAILURE, error }
  }
}

function openConversationFromNotificationLink(key) {
  return (dispatch) => {
    dispatch(request(key))

    messengerService.openConversationFromNotificationLink(key).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: mc.OPEN_CONVERSATION_FROM_NOTIFICATION_LINK_REQUEST, data }
  }
  function success(data) {
    return { type: mc.OPEN_CONVERSATION_FROM_NOTIFICATION_LINK_SUCCESS, data }
  }
  function failure(error) {
    return { type: mc.OPEN_CONVERSATION_FROM_NOTIFICATION_LINK_FAILURE, error }
  }
}

function createConversationFromMailLink(key1, key2) {
  return (dispatch) => {
    dispatch(request(key1, key2))

    messengerService.createConversationFromMailLink(key1, key2).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: mc.CREATE_CONVERSATION_FROM_MAIL_LINK_REQUEST, data }
  }
  function success(data) {
    return { type: mc.CREATE_CONVERSATION_FROM_MAIL_LINK_SUCCESS, data }
  }
  function failure(error) {
    return { type: mc.CREATE_CONVERSATION_FROM_MAIL_LINK_FAILURE, error }
  }
}

function saveDraftMessage(conversation_id, origin_message_id, message = '', file_ids) {
  return (dispatch) => {
    dispatch(request({ conversation_id, origin_message_id, message, file_ids }))

    messengerService.saveDraftMessage(conversation_id, origin_message_id, message, file_ids).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: mc.ADD_DRAFT_MESSAGE_REQUEST, data, message }
  }
  function success(data) {
    return { type: mc.ADD_DRAFT_MESSAGE_SUCCESS, data, message }
  }
  function failure(error) {
    return { type: mc.ADD_DRAFT_MESSAGE_FAILURE, error }
  }
}

function setFilterItem(filterItem) {
  return {
    type: mc.SET_FILTER_ITEM,
    filterItem
  }
}

function addToPendingMessages(messageObject) {
  return {
    type: mc.ADD_TO_PENDING_MESSAGES,
    messageObject
  }
}

function removeFromPendingMessages(messageId) {
  return {
    type: mc.REMOVE_FROM_PENDING_MESSAGES,
    messageId
  }
}

function locateMessageInConversation(conversation_id, message_id) {
  return (dispatch) => {
    dispatch(request({ conversation_id, message_id }))

    messengerService.locateMessageInConversation(conversation_id, message_id).then(
      (response) => {
        dispatch(success({ ...response, conversation_id, message_id }))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.LOCATE_MESSAGE_IN_CONV_REQUEST, response }
  }
  function success(response) {
    return { type: mc.LOCATE_MESSAGE_IN_CONV_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.LOCATE_MESSAGE_IN_CONV_FAILURE, error }
  }
}

function resetScrollToMessage() {
  return {
    type: mc.RESET_SCROLL_TO_MESSAGE
  }
}

function createBackgroundTagMsgr(
  conversationId,
  imagesCount,
  documentsCount,
  originMessageId,
  message,
  tempMessageId,
  taggedGroupIds,
  taggedMixrIds
) {
  const parsedMessage = getParsedMessage(message)
  const taggedUserIds = getTaggedUserIds(parsedMessage)
  const containedLinks = getLinksFromMessage(parsedMessage)
  return (dispatch) => {
    dispatch(request({ conversationId, imagesCount, documentsCount, originMessageId }))
    messengerService
      .createBackgroundTagMsgr(
        conversationId,
        imagesCount,
        documentsCount,
        originMessageId,
        message,
        taggedUserIds,
        taggedGroupIds,
        taggedMixrIds,
        containedLinks
      )
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
  }

  function request(response) {
    return { type: mc.CREATE_BG_TAG_REQUEST, response }
  }
  function success(response) {
    return { type: mc.CREATE_BG_TAG_SUCCESS, response, tempMessageId }
  }
  function failure(error) {
    return { type: mc.CREATE_BG_TAG_FAILURE, error }
  }
}

function updateProcessedTag(tag) {
  return { type: mc.UPDATE_PROCESSED_TAG, tag }
}
